import React from "react";
import { columns } from "./Columns";
import { videoCategoriesApi } from "@/apis/apis";
import MasterDataBaseTable from "@/pages/WebDataManagement/MasterData/MasterDataBaseTable";
import VideoCategoryModal from "@/Modals/ContentManagement/VideoCategories/Modal";

export default function VideoCategoriesPage() {
  return (
    <MasterDataBaseTable
      label="Video Category"
      apiURL={videoCategoriesApi}
      columns={columns()}
      ModalComponent={VideoCategoryModal}
      enableSortData={true}
      enableExport={false}
    />
  );
}
